/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRepeatOnce = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="m21.71 5.292-3.003-3-1.414 1.416L18.587 5H1.997v5h2V7h14.59l-1.294 1.292 1.414 1.416 3.004-3L22.419 6zM20.005 14v3H5.413l1.294-1.292-1.414-1.416-3.004 3-.708.708.708.708 3.004 3 1.414-1.416L5.413 19h16.59v-5zm-8.339-3.77V15h1.413V8.547h-.999l-1.908 1.359v.828z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgRepeatOnce as RepeatOnce };
